<template>
  <div>
    <BreadCrumb crumb="修改密码"></BreadCrumb>
    <div class="per_info">
        <el-form :model="ReSetPWDForm" status-icon :rules="rulesReSetPWDForm" ref="ReSetPWDForm" label-width="100px">
          <el-form-item label="旧密码：" prop="pwd1">
            <el-input type="password" v-model="ReSetPWDForm.pwd1" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="pwd2">
            <el-input type="password" v-model="ReSetPWDForm.pwd2" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码：" prop="pwd3">
            <el-input type="password" v-model="ReSetPWDForm.pwd3" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('ReSetPWDForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </div>

  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import cons from '@/components/constant'

export default {
  name: 'ReSetPWD',
  data () {
    var validatePwd1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码不能为空!'));
        } else {
          var rePass = /^[\w!@#$%^&*]{8,20}$/;
          if(rePass.test(value))
          {
            callback()
          }else{
             callback(new Error('密码是8到20位数字、字母或_@#$%^&*符号'));
          }
        }
    };
    var validatePwd2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码不能为空!'));
        } else {
          var rePass = /^[\w!@#$%^&*]{8,20}$/;
          if(rePass.test(value))
          {
            if(value === this.ReSetPWDForm.pwd1)
            {
               callback(new Error('新旧密码不能重复！'));

            }else{
              callback()
            }
          }else{
             callback(new Error('密码是8到20位数字、字母或_@#$%^&*符号'));
          }
        }
    };
    var validatePwd3 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('确认密码不能为空!'));
        } else {
          if(value === this.ReSetPWDForm.pwd2)
          {
            callback()
          }else{
             callback(new Error('两次输入密码不一致！'));
          }
        }
    };

    return {
      ReSetPWDForm: {
        pwd1: '',
        pwd2: '',
        pwd3: '',
      },
      rulesReSetPWDForm: {
        pwd1: [
            { validator: validatePwd1, trigger: 'blur' }
        ],
        pwd2: [
            { validator: validatePwd2, trigger: 'blur' }
        ],
        pwd3: [
            { validator: validatePwd3, trigger: 'blur' }
        ]
      }
    }
  },
  components:{
    BreadCrumb,
  },
  methods:{
    submitForm(){
      if(this.ReSetPWDForm.pwd1 === '' ||this.ReSetPWDForm.pwd2 === '' ||this.ReSetPWDForm.pwd3 === ''){
        this.$message({
          type: 'error',
          message: '任何密码不能为空!'
        });
        return
      }
      let token = localStorage.token;
      this.axios.put(cons.apis + '/v1_0/password', {
              "old_password": this.ReSetPWDForm.pwd1,  // 旧密码
              "password": this.ReSetPWDForm.pwd2  // 新密码
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          // this.resetForm('ReSetPWDForm');
          this.$router.push({path:'/home'});
        }).catch(err=>{
          this.$message({
            type: 'error',
            message: '旧密码错误!'
          });
          console.log(err.response);
        })
    },
  }
}
</script>

<style scoped>
  .per_info {
    background: #fff;
    padding: 100px 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/ReSetPWD.vue